import React, { useContext, useEffect, useState } from 'react';
import { withRouter, Link } from "react-router-dom";
import { StateContext } from 'context';
import { LogoTipoBlanco} from 'assets/logos';
import './header.css';

import useScrollPosition from '@react-hook/window-scroll';
import { Themes } from 'styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Header = (props) => {
    const scrollY = useScrollPosition(60);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 5;
    const [open, setOpen] = useState(false);
    const [seccionActiva, setSeccionActiva] = useState('inicio');
    const [isScrolling, setIsScrolling] = useState(false);
    const [hoveredButton, setHoveredButton] = useState(null);
    
    useEffect(() => {
        const handleScroll = () => {
            // No detectar sección si estamos haciendo scroll programático
            if (isScrolling) return;
            
            const secciones = ['inicio', 'paquetes', 'servicios', 'nosotros', 'contacto'];
            const offset = 270; // Ajusta este valor según la altura de tu header
            
            // Si está en la parte superior de la página
            if (window.scrollY < 100) {
                setSeccionActiva('inicio');
                return;
            }
            
            for (let i = secciones.length - 1; i >= 0; i--) {
                const elemento = document.getElementById(secciones[i]);
                if (elemento) {
                    const rect = elemento.getBoundingClientRect();
                    if (rect.top <= offset) {
                        setSeccionActiva(secciones[i]);
                        break;
                    }
                }
            }
        };
        
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Llamada inicial
        
        return () => window.removeEventListener('scroll', handleScroll);
    }, [isScrolling]);
    
    const scrollA = (target) => {
        setOpen(false);
        setSeccionActiva(target);
        setIsScrolling(true);
        
        props.scrollear(target);
        
        // Reactivar la detección después de que termine el scroll
        setTimeout(() => {
            setIsScrolling(false);
        }, 1000);
    };
    
    const getButtonStyle = (seccion) => {
        const isActive = seccionActiva === seccion;
        const isHovered = hoveredButton === seccion;
        return {
            backgroundColor: isActive ? Themes[indexTema].D4 : 'transparent',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            padding: '12px 28px',
            fontSize: '13px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.5s',
            letterSpacing: '0.5px',
             transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
            boxShadow: isHovered ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
            ...(isHovered && !isActive && { backgroundColor: Themes[indexTema].D4 })
        };
    };
    
    const irAlMain = () => {
        window.location.href = '/';
    };
    return (
        <>
            <div id="header-top" className="w3-block w3-hide-small bs-bbox animate__animated animate__fadeInDown" 
                style={{ 
                    backgroundColor: ((scrollY && scrollY > 200) || props.paginaIndividual) ? Themes[indexTema].D2 : 'rgba(0,0,0,0.2)', 
                    // position: scrollY && scrollY > 200 ? 'fixed' : 'absolute',
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 20,
                    transition: 'all 0.3s ease'
                }}>
                <div className="w3-block">
                    <div className="w3-content" style={{ maxWidth: 1400 }}>
                        <div className="w3-row" style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                            <div className="w3-col logo-cont" style={{ width: '200px' }}>
                                {!props.paginaIndividual ? 
                                <button onClick={() => { scrollA('inicio'); }} className="w3-transparent" style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                                    <img src={LogoTipoBlanco} alt="LogoTipo" style={{ maxHeight: '250px' }} />
                                </button> :
                                <button onClick={() => { irAlMain() }} className="w3-transparent" style={{ border: 'none', background: 'transparent', cursor: 'pointer' }}>
                                    <img src={LogoTipoBlanco} alt="LogoTipo" style={{ maxHeight: '250px' }} />
                                </button>}
                            </div>
                            <div className="w3-rest menu-container" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <nav className="nav-menu">
                                    <ul style={{ display: 'flex', listStyle: 'none', margin: 0, padding: 0, gap: '5px', alignItems: 'center' }}>
                                        {!props.paginaIndividual ? <>
                                            <li>
                                            <button className="header-btn" onClick={() => scrollA('inicio')} 
                                                onMouseEnter={() => setHoveredButton('inicio')}
                                                onMouseLeave={() => setHoveredButton(null)}
                                                style={getButtonStyle('inicio')}>
                                                Inicio
                                            </button> 
                                        </li>
                                        <li>
                                            <button className="header-btn" onClick={() => scrollA('paquetes')} 
                                                style={getButtonStyle('paquetes')}
                                                onMouseEnter={() => setHoveredButton('paquetes')}
                                                onMouseLeave={() => setHoveredButton(null)}>
                                                Destinos
                                            </button>
                                        </li>
                                        <li>
                                            <button className="header-btn" onClick={() => scrollA('servicios')}
                                                onMouseEnter={() => setHoveredButton('servicios')}
                                                onMouseLeave={() => setHoveredButton(null)} 
                                                style={getButtonStyle('servicios')}>
                                                Servicios
                                            </button>
                                        </li>
                                        <li>
                                            <button className="header-btn" onClick={() => scrollA('nosotros')} 
                                                onMouseEnter={() => setHoveredButton('nosotros')}
                                                onMouseLeave={() => setHoveredButton(null)}
                                                style={getButtonStyle('nosotros')}>
                                                Nosotros
                                            </button>
                                        </li>
                                        </> : null}
                                        <li>
                                            <button className="header-btn" onClick={() => scrollA('contacto')} 
                                                onMouseEnter={() => setHoveredButton('contacto')}
                                                onMouseLeave={() => setHoveredButton(null)}
                                                style={getButtonStyle('contacto')}>
                                                Contacto
                                            </button>
                                        </li>
                                        <li style={{ marginLeft: '15px', display: 'flex', gap: '35px' }}>
                                            <a href="tel:+59521210363" rel="noreferrer" 
                                                style={{
                                                    color: 'white',
                                                    textDecoration: 'none',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                aria-label="Teléfono">
                                                <FontAwesomeIcon icon={faPhoneAlt} color="#fff" size="1x" />
                                                +595 (021) 210 363
                                            </a>

                                            <a href="https://wa.me/595986229400" rel="noreferrer" 
                                                style={{
                                                    color: 'white',
                                                    textDecoration: 'none',
                                                    fontSize: '14px',
                                                    fontWeight: '600',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    transition: 'transform 0.3s ease',
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                aria-label="Celular Whatsapp">
                                                <FontAwesomeIcon icon={faWhatsapp} color="#fff" size="1x" />
                                                +595 986 229 400
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="w3-block w3-hide-medium w3-hide-large bs-bbox" style={{ position: 'fixed', zIndex: 20, width: '100%', top: 0 }}>
                <div className="w3-block" style={{ backgroundColor: Themes[indexTema].D2 }}>
                    <div className="w3-content">
                        <div className="w3-row">
                            <div className="w3-col logo-cont">
                                <Link to="/"><img src={LogoTipoBlanco} alt="LogoTipo" /></Link>
                            </div>
                            <div className="w3-rest padding-header bs-bbox">
                                <button className="w3-btn w3-transparent w3-text-white w3-right" name='menu' aria-label='menu' 
                                    onClick={() => setOpen(!open)}>
                                    <FontAwesomeIcon icon={faBars} size="3x"></FontAwesomeIcon>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {open ? <div className="w3-block padding-header bs-bbox animate__animated animate__fadeIn menu-pantalla-min" style={{ backgroundColor: Themes[indexTema].D1 }}>
                    <nav>
                        <ul className="w3-block" style={{ listStyleType: 'none', padding: 0 }}>
                            {!props.paginaIndividual ? <>
                            <li style={{ backgroundColor: seccionActiva === 'inicio' ? Themes[indexTema].D4 : 'transparent' }}>
                                <button className="w3-transparent w3-text-white w3-border-0 w3-block padding-header bs-bbox w3-margin" onClick={() => scrollA('inicio')}>INICIO</button>
                            </li>
                            <li style={{ backgroundColor: seccionActiva === 'paquetes' ? Themes[indexTema].D4 : 'transparent' }}>
                                <button className="w3-transparent w3-text-white w3-border-0 w3-block padding-header bs-bbox w3-margin" onClick={() => scrollA('paquetes')}>DESTINOS</button>
                            </li>
                            <li style={{ backgroundColor: seccionActiva === 'servicios' ? Themes[indexTema].D4 : 'transparent' }}>
                                <button className="w3-transparent w3-text-white w3-border-0 w3-block padding-header bs-bbox w3-margin" onClick={() => scrollA('servicios')}>SERVICIOS</button>
                            </li>
                            <li style={{ backgroundColor: seccionActiva === 'nosotros' ? Themes[indexTema].D4 : 'transparent' }}>
                                <button className="w3-transparent w3-text-white w3-border-0 w3-block padding-header bs-bbox w3-margin" onClick={() => scrollA('nosotros')}>NOSOTROS</button>
                            </li>
                            </> : null}
                            <li style={{ backgroundColor: seccionActiva === 'contacto' ? Themes[indexTema].D4 : 'transparent' }}>
                                <button className="w3-transparent w3-text-white w3-border-0 w3-block padding-header bs-bbox w3-margin" onClick={() => scrollA('contacto')}>CONTACTO</button>
                            </li>
                            <li>
                                <a className="w3-transparent w3-text-white w3-border-0 w3-center w3-block" href="tel:+59521210363" rel="noreferrer" aria-label="Teléfono" style={{textDecoration:'none'}}>
                                    <FontAwesomeIcon icon={faPhoneAlt} color="#fff" size="1x" /> &nbsp;+595 (021) 210 363
                                </a>
                            </li>
                            <li>
                                     <a className="w3-transparent w3-text-white w3-border-0 w3-center w3-block" href="https://wa.me/595986229400" rel="noreferrer" aria-label="Teléfono" style={{textDecoration:'none'}}>
                                    <FontAwesomeIcon icon={faWhatsapp} color="#fff" size="1x" /> &nbsp;+595 986 229 400
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div> : null}
            </div>
            <div className="w3-block w3-hide-medium w3-hide-large" style={{ height: 85 }}>
            </div>
        </>
    );
}
export default withRouter(Header);